export default function DuringYourStay() {
  return (
    <div className="mb-4">
      <div className="text-left">
        <p className="text-base font-bold text-black222 mb-2 ">
          During your stay
        </p>
        <p className="text-base  ">
          Any concerns guests have, I'm fully available to respond via Airbnb or
          directly via wapp.
        </p>
      </div>
    </div>
  );
}
